<template>
    <div class="navCen">
        <div class="top">
            <p class="title">概述</p>
            <div class="border"></div>
            <p class="text">MTCal是兆物信连自主研发的一套基于AIO-3399C高性能开源平台的小型嵌入式主机，它的出现为区块链数据应用上链创建了一个绿色安全可信可靠的通道。</p>
            <img class="imgs" src="../../assets/scheme/Page4.png" style="width:268px;height: 262px;">
            <p class="title01">产品特性</p>
            <div class="border"></div>
            <p class="text2">MTCal外观小巧精致，配备工业级外壳，采用无风扇高效散热设计，耐高温，7x24小时稳定运作，接口齐全，适用性强，可直接驱动主流5~100寸的显示屏，轻松嵌入各种智能产品中。</p>
            <p class="text2">
                MTCal采用兆物信连自主研发的可控、安全可靠，安全优化，安全加固，以Linux技术为核心的国产MT操作系统。支持国家密码管理部门发布的SM2、SM3、SM4等国密算法；兼容主流的软硬件和自主CPU平台；可为设备提供持续性安全保障，防止软硬件被篡改和信息被窃取，系统免受攻击；为业务应用平台提供全方位的安全保护，保障关键应用安全、可信和稳定的对外提供服务。</p>
            <img src="../../assets/scheme/Page5.png"style="width:416px;height: 290px;margin-top: 30px;">
        </div>
    </div>
</template>

<script>
    export default {
        name: "mtcal"
    }
</script>

<style scoped lang="scss">
    .navCen {
        position: relative;
        .top {
            margin: 85px 84px 100px;
            .title {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #282F3C;
                margin-left: 9px;
            }
            .imgs{
                position: absolute;
                right:400px;
                top: 30px;
            }
            .border {
                width: 27px;
                height: 3px;
                margin-top: 3px;
                background-color: #056DFF;
            }
            .text {
                width: 445px;
                height: 110px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #353F52;
                line-height: 30px;
                margin-top: 56px;
            }
            .title01{
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #282F3C;
                margin-left: 9px;
                margin-top:126px;
            }
            .text2 {
                width: 822px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #353F52;
                line-height: 30px;
                margin-top: 56px;
            }
        }
    }

</style>
